import * as React from 'react';
import { IMetroStation, IRoad, METRO_TRAVEL_TYPE_ICON } from '../utils';
import { MetroStationItem, MetroAndRoadsLayout, RoadItem } from '../../../components/Infrastructure';

interface IMetroAndRoadsContainerProps {
  metroStations: IMetroStation[];
  roads: IRoad[];
}

export const MetroAndRoadsContainer: React.FC<IMetroAndRoadsContainerProps> = ({ metroStations, roads }) => {
  if (!metroStations.length && !roads.length) {
    return null;
  }

  return (
    <MetroAndRoadsLayout>
      {metroStations.map(({ travelType, name, travelTime, color }, index) => {
        const IconComponent = METRO_TRAVEL_TYPE_ICON[travelType];

        return (
          <MetroStationItem
            key={name + index}
            name={name}
            travelTime={travelTime}
            color={color}
            icon={<IconComponent color="icon-secondary-default" />}
          />
        );
      })}
      {roads.map(({ name, distance }, index) => {
        return <RoadItem key={name + index} name={name} distance={distance} />;
      })}
    </MetroAndRoadsLayout>
  );
};
